'use client';
import { Experience } from '@ninetailed/experience.js-react';
import { Suspense } from 'react';
import { parseExperiences } from '../lib/experiences-nt';
import dynamic from 'next/dynamic';
const Nav = dynamic(() => import('../components/nav'));
const PageIntroLevel0Display = dynamic(() =>
    import('@fm-nx/ui').then((mod) => ({ default: mod.PageIntroLevel0Display }))
);
const BlockRenderer = dynamic(() => import('@fm-nx/ui').then((mod) => ({ default: mod.BlockRenderer })));

export default function HomePage({ page, preview }: { page: any; preview: boolean }) {
    const { sections = [], pageIntro } = page.fields;
    const parsedExperiences = parseExperiences(pageIntro);

    const params = {
        intro: pageIntro,
    };

    return (
        <div>
            <Nav variant="dark-transparent" preview={preview} />
            {pageIntro && (
                <>
                    <Experience
                        {...params}
                        id={pageIntro.sys.id}
                        component={PageIntroLevel0Display}
                        experiences={parsedExperiences}
                        passthroughProps={{
                            headerText: pageIntro.fields.headerText,
                            headerParagraph: pageIntro.fields.headerParagraph,
                            button: {
                                ...pageIntro.fields.button,
                                sys: { id: pageIntro.fields.button?.sys.id || '' },
                                __typename: 'Button',
                            },
                        }}
                    />
                </>
            )}
            <Suspense fallback={<div className="h-64"></div>}>
                <BlockRenderer block={sections} />
            </Suspense>
        </div>
    );
}
